<div class="bg">
        <div class="note-container">
          <div class="sticky-note sticky-note-two" contenteditable="true" style="font-family: '72', '72full', 'Roboto', Helvetica, sans-serif;">Geschäftspartner<p></p>1010000669<p></p>Vertragskonto<p></p>201000012222<p></p>Vertrag<p></p>3010002299<p></p>Anlage<p></p>60003406<p></p>Zähler<p></p>10001</div>
        </div>
</div>
